<template>
  <div style="min-height: 100vh;">
    <van-notice-bar
      left-icon="volume-o"
      text="草稿只保存30天，到期自动删除"
      color="#FF6B31" background="#FFF6F3"
    />

    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <div>
        <div v-for="(item, index) in list" :key="index">
          <div class="card-content-lsy">
            <div class="flex-wrapper">
              <div class="card-media small">
                <van-image width="115" height="95" :src="item.backgroundImg" />
              </div>
              <div class="flex-grow">
                <div class="card-inner">
                  <div class="card-title">{{item.activityTitle}}</div>
                </div>
                <div class="card-inner">
                  <div class="card-text">
                    <div>开始时间：{{item.startTime | shortDate}}</div>
                    <div>截止时间：{{item.endTime | shortDate}}</div>
                  </div>
                </div>
                <div class="card-inner">
                  <div v-if="+item.signUpfee > 0">
                    {{item.signUpfeeLable}}
                    <span class="price">¥{{item.signUpfee}}</span>
                  </div>
                  <span v-else class="price">免费</span>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="card-btn" @click="del(item)">删除</div>
              <div class="card-btn" @click="edit(item.activityId)">编辑</div>
            </div>
          </div>
        </div>
      </div>
    </refresh-list>
    
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
export default {
  components: {
    refreshList
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      list: []
    }
  },
  methods: {
    del(item) {
      this.$funcDialog.show({
        content: '请问是否删除当前草稿？<br/>删除后将不可恢复！'
      })
      this.$funcDialog.addEventListener(status=>{
        if (status == 'cancel') return
        this.$api.h5.deleteActivity(item.activityId)
        .then(res=>{
          if(res.code == 200) {
            this.$toast('删除成功')
            this.list = this.list.filter(v=>v.activityId != item.activityId);
          }else{
            this.$toast(res.message)
          }
        })
      });
    },
    edit(activityId) {
      this.$router.push({
        path: '/activity/edit',
        query: {
          activityId
        }
      })
    },
    onLoad() {
      this.getActivityData();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getActivityData();
    },
    getActivityData() {
      let data = {
        filterData: {
          activityName: '',
          dataType: '0'
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.h5.home(data)
      .then(res=>{
        if(res.code == 200) {
          this.list.push(...res.data.list);
          this.pageNum = res.data.pageNum + 1;
          this.$refs['refreshList'].complete(res.data);
        }else{
          this.$refs['refreshList'].onFinish();
        }
      })
    }
  },
  created() {
    this.onLoad();
  }
}
</script>

<style lang="stylus" scoped>
  .price
    color #FF6B31
    font-size 14px
</style>